document
  .querySelector(".read-more-page-btn")
  ?.addEventListener("click", function () {
    const btn = this;
    const section = document.querySelector(".default-collection-section");
   const isArabic = Shopify.locale === "ar";

    const readMoreText = isArabic ? `مشاهدة المزيد` : "Read More";
    const readLessText = isArabic ? `مشاهدة أقل` : "Read Less";
    if (section.classList.contains("read-more-page-content")) {
      // Expand
      section.classList.remove("read-more-page-content");
      btn.setAttribute("aria-expanded", "true");
      btn.textContent = readLessText;
    } else {
      // Collapse
      section.classList.add("read-more-page-content");
      btn.setAttribute("aria-expanded", "false");
      btn.textContent = readMoreText;
    }
  });
console.log("testing");
console.log(Shopify.locale);